import Vue from "vue";
import VueRouter from "vue-router";
import CLCHomePage from "@/components/CLCHomePage";
import CLCNewsDetail from "@/components/CLCNewsDetail";
import CLCNewsList from "@/components/CLCNewsList";
import Preview from "@/components/Preview";
import CLCVideoPage from "@/components/CLCVideoPage";

Vue.use(VueRouter);

const routes = [
  {
    path: "/preview",
    component: Preview,
  },
  {
    path: "/",
    component: CLCHomePage,
  },
  {
    path: "/en/",
    component: CLCHomePage,
  },
  {
    path: "/es/",
    component: CLCHomePage,
  },
  {
    path: "/en/news",
    component: CLCNewsList,
  },
  {
    path: "/es/news",
    component: CLCNewsList,
  },
  // Página suelta con un solo video en loop (sin rail ni footer).
  {
    path: "/video",
    component: CLCVideoPage,
  },
  {
    path: "/en/news/:id",
    component: CLCNewsDetail,
  },
  {
    path: "/es/news/:id",
    component: CLCNewsDetail,
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

export default router;
